import { forwardRef } from 'react';
import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';
import * as styles from './styles';
import type { StyleProps } from './styles';
import { Label } from '../Label';
import { InputError } from '../InputError';

type TextareaTypeMap = BaseTypeMap<
  'textarea',
  Omit<StyleProps, 'intent'> & {
    label: string;
    name: string;
    error?: string | string[];
    id?: string;
  }
>;

export type TextareaProps = ComponentProps<TextareaTypeMap>;

export const Textarea: Component<TextareaTypeMap> = forwardRef(
  function Textarea(
    { className, label, disabled, name, error, id, ...rest },
    ref
  ) {
    return (
      <Box className={className}>
        <Box className="relative pt-5">
          <Label
            as="label"
            htmlFor={id || name}
            rise={!!rest.value}
            disabled={!!disabled}
          >
            {!rest.required ? `${label}` : `${label} *`}
          </Label>
          <Box
            as="textarea"
            {...rest}
            ref={ref}
            className={styles.textarea({
              disabled: !!disabled,
            })}
            disabled={disabled}
            aria-describedby={`${id || name}-desc`}
            name={name}
            id={id || name}
            aria-invalid={!!error ? 'true' : undefined}
          />
        </Box>
        <InputError error={error} id={`${name}-desc`} />
      </Box>
    );
  }
);
